export const LimitTypeEnum = {
  CourseCreation: 0,
  AICourseCreation: 1,
  ReportView: 2,
}
